import MembershipRevenueModule from "./membershipRevanueModule";
import MembershipRevenueSagas from "./redux/membershipRevenueSagas";
import MembershipRevenueReducer from "./redux/membershipRevenueReducer";

export default {
  Component: MembershipRevenueModule,
  moduleName: "membershipRevenue",
  saga: MembershipRevenueSagas(),
  reducer: MembershipRevenueReducer
};
